import React, { FC } from "react";
import classNames from "classnames/dedupe";

export type TDividerSize = "thin" | "bold";
export type TDividerColor = "blue" | "grey" | "white" | "dark-blue";
export type TDividerDirection = "horizontal" | "vertical";

export interface IDividerProps {
  /**
   * The custom set of css classes used to style component
   *
   * root: applied to outer div element
   */
  classes?: { root?: string };
  isMobile?: boolean;
  style?: React.CSSProperties;
  size?: TDividerSize;
  color?: TDividerColor;
  dir?: TDividerDirection;
}

const Divider: FC<IDividerProps> = ({
  classes,
  isMobile,
  size = "thin",
  color = "blue",
  style,
  dir = "horizontal",
}) => {
  const rootClasses = classNames(
    "divider",
    { "divider--vertical-bold": dir === "vertical" && size === "bold" },
    { "divider--vertical-thin": dir === "vertical" && size === "thin" },
    { "divider--thin": size === "thin" && dir === "horizontal" },
    { "divider--bold": size === "bold" && dir === "horizontal" },
    { "divider--blue": color === "blue" },
    { "divider--white": color === "white" },
    { "divider--dark-blue": color === "dark-blue" },
    { "divider--grey": color === "grey" },
    classes?.root,
  );

  return isMobile ? (
    <div className="mobile-menu-divider-container" style={style}>
      <div className={rootClasses} />
    </div>
  ) : (
    <div className={rootClasses} style={style} />
  );
};

export default Divider;
